import { useLocation, useNavigate } from 'react-router-dom';

// you probably don't want to call this hook upon 401 Unauthorized
// otherwise you will end up in an infinite loop
export function useRedirectToLogin() {
  const location = useLocation();
  const navigate = useNavigate();

  return () => {
    navigate('/login', { state: { from: location } });
  };
}
